module.exports = __webpack_public_path__ + "static/media/01-CityDuck.49e42e31.webp";